/** DraftsFilterBar — 草稿箱筛选行：归属（全部/自由起草/按事项）、文书类型、
 * 状态、标题搜索。纯受控组件，筛选状态由页面持有（URL 同步）。 */

import { SearchOutlined } from "@ant-design/icons";
import { Input, Select } from "antd";
import type { DraftDocStatus, DraftDocType } from "../../types";
import {
  DRAFT_DOC_STATUS_LABELS,
  DRAFT_DOC_TYPE_OPTIONS,
} from "../../types";
import styles from "./draft.module.css";

/** 归属筛选的固定取值；除此之外的值为事项 UUID（按事项过滤）。 */
export const OWNERSHIP_ALL = "all";
export const OWNERSHIP_UNASSIGNED = "unassigned";

export interface DraftsFilterValues {
  /** OWNERSHIP_ALL | OWNERSHIP_UNASSIGNED | 事项 UUID */
  ownership: string;
  docType?: DraftDocType;
  status?: DraftDocStatus;
  /** 标题模糊搜索关键词（未防抖的原始输入） */
  q: string;
}

export const DRAFT_DOC_STATUS_OPTIONS: { value: DraftDocStatus; label: string }[] = (
  Object.entries(DRAFT_DOC_STATUS_LABELS) as [DraftDocStatus, string][]
).map(([value, label]) => ({ value, label }));

interface DraftsFilterBarProps {
  value: DraftsFilterValues;
  onChange: (next: DraftsFilterValues) => void;
  matterOptions: { value: string; label: string }[];
  mattersLoading?: boolean;
}

export function DraftsFilterBar({
  value,
  onChange,
  matterOptions,
  mattersLoading,
}: DraftsFilterBarProps) {
  const ownershipOptions = [
    { value: OWNERSHIP_ALL, label: "全部归属" },
    { value: OWNERSHIP_UNASSIGNED, label: "自由起草（无事项）" },
    ...matterOptions,
  ];

  return (
    <div className={styles.inboxFilterBar} data-testid="drafts-filter-bar">
      <Select
        className={styles.inboxFilterSelect}
        popupMatchSelectWidth={false}
        showSearch
        optionFilterProp="label"
        value={value.ownership}
        onChange={(ownership) => onChange({ ...value, ownership })}
        options={ownershipOptions}
        loading={mattersLoading}
        aria-label="按归属筛选"
      />
      <Select
        className={styles.inboxFilterSelect}
        popupMatchSelectWidth={false}
        placeholder="文书类型"
        allowClear
        value={value.docType}
        onChange={(docType) => onChange({ ...value, docType })}
        options={DRAFT_DOC_TYPE_OPTIONS}
        aria-label="按文书类型筛选"
      />
      <Select
        className={styles.inboxFilterSelect}
        popupMatchSelectWidth={false}
        placeholder="状态"
        allowClear
        value={value.status}
        onChange={(status) => onChange({ ...value, status })}
        options={DRAFT_DOC_STATUS_OPTIONS}
        aria-label="按状态筛选"
      />
      <Input
        className={styles.inboxSearchInput}
        allowClear
        prefix={<SearchOutlined />}
        placeholder="搜索草稿标题..."
        aria-label="搜索草稿标题"
        value={value.q}
        onChange={(e) => onChange({ ...value, q: e.target.value })}
      />
    </div>
  );
}
